import React, { useEffect, useState, useRef } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";
import ModeloUpload from "../../../assets/statics/modelo_estoque.xlsx";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import {
  allExcelColumns,
  excelColumnsPtBr,
  findRowsWithError,
  validateDuplicity,
  getValidsGroups,
  formatGroups,
} from "./ImportValidation";
import ModalExcelRows from "../Voo/ModalExcelRows";
import ModalRowsDuplicity from "./ModalRowsDuplicity";
import moment from "moment";
import { toast } from "react-toastify";
import {
  importStock,
  createStockActivity,
} from "../../../utils/services/schedulingAndStock";

export default function ModalImportStock(props) {
  const { toggleModal, idEvent, refetch, jwt } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [success_dlg, setSuccessDlg] = useState(false);
  const [imgError, setImgError] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const importActivated = useRef(false);

  const [modalErrors, setModalErrors] = useState(false);
  const [modalRowsDuplicity, setModalRowsDuplicity] = useState(false);
  const [errors, setErrors] = useState([]);

  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setSelectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    setImgError("");
    importActivated.current = false;
    setSelectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      Sala: {
        prop: "room",
        type: String,
      },
      Atividade: {
        prop: "task",
        type: String,
      },
      "Data e Hora Inicio": {
        prop: "initialDate",
        type: Date,
        parse(value) {
          return moment(value, "DD/MM/YYYY, HH:mm")
            .subtract(3, "hours")
            .toDate();
        },
      },
      "Data e Hora Fim": {
        prop: "endDate",
        type: Date,
        parse(value) {
          return moment(value, "DD/MM/YYYY, HH:mm")
            .subtract(3, "hours")
            .toDate();
        },
      },
      "Quantidade Máxima": {
        prop: "maxQuantity",
        type: Number,
      },
      Tipo: {
        prop: "tipo",
        type: String,
      },
      "Segregar Por Grupos": {
        prop: "segragate",
        type: String,
      },
      "Grupos e Quantidades": {
        prop: "groups",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      try {
        setImgError("");

        const { rows } = await readXlsxFile(selectedFiles[0], { schema });
        const validRows = rows.map((row, i) => allExcelColumns(row, i));
        // validar colunas se esta no padrão
        const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
        const header = rowsWithoutSchema[0];
        const schemaCreate = Object.keys(schema);

        function isEqual(schema, header) {
          if (schema.length !== header.length) return false;

          return (
            schema.every((item) => header.includes(item)) &&
            header.every((item) => schema.includes(item))
          );
        }

        if (!isEqual(schemaCreate, header)) {
          setErrors([]);
          setModalErrors(true);
          return;
        }

        const rowsDuplicity = await validateDuplicity(validRows);

        setTotalRows(validRows.length);
        const rowsWithError = await findRowsWithError(validRows);

        if (rowsWithError.length > 0 || validRows.length === 0) {
          setErrors(rowsWithError);
          setModalErrors(true);
          return;
        }

        if (rowsDuplicity.length > 0) {
          setErrors(rowsDuplicity);
          setModalRowsDuplicity(true);
          return;
        }

        const invalidsGroups = await getValidsGroups(idEvent, validRows);

        if (invalidsGroups.length > 0) {
          setErrors(invalidsGroups);
          setModalErrors(true);
          return;
        }

        for (const row of validRows) {
          await importStockService(row, validRows.length);
        }
      } catch (error) {
        console.error("Error reading file:", error);
        setImgError("Erro ao ler o arquivo. Verifique o formato.");
      }
    };

    readXlsx();

    async function importStockService(row, rowsCount) {
      const groups = await formatGroups(row, idEvent);

      const dataForm = {
        eventId: idEvent,
        dataHoraInicio: row.initialDate,
        dataHoraFim: row.endDate,
        quantidadeMax: Number(row.maxQuantity),
        quantidadeUtilizada: 0,
        atividade: row.task,
        tipo: row.tipo,
        sala: row.room,
        segregarPorGrupo:
          row?.segragate?.toUpperCase() === "SIM" ? true : false,
        grupos: groups,
      };

      await createStockActivity(dataForm, jwt)
        .then((res) => {
          if (res.message === "CREATED") {
            setTotalSended(count++);
          }

          if (rowsCount === count || (count === 2 && rowsCount === 1)) {
            setBtnCancel(false);
            setSuccessDlg(true);
          }
        })
        .catch((error) => {
          console.error("Erro ao criar atividade de estoque:", error);
          toast.error(
            `Erro ao importar a atividade "${row.task}" (sala ${row.room}).`,
          );
        });
    }
  }

  return (
    <>
      {success_dlg && (
        <SweetAlert
          success
          title="Upload"
          onConfirm={() => {
            refetch();
            toggleModal();
            setSuccessDlg(false);
          }}
        >
          O arquivo foi enviado com sucesso!
        </SweetAlert>
      )}

      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
        />
      )}

      {modalRowsDuplicity && (
        <ModalRowsDuplicity
          toggle={() => setModalRowsDuplicity(false)}
          rows={errors}
        />
      )}
      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_estoque.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}

            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => (
                <Card
                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                  key={i + "-file"}
                >
                  <div className="p-1">
                    <Row className="align-items-center">
                      <Col xs="11">
                        <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                      </Col>
                      <Col xs="1">
                        <span
                          style={{
                            fontSize: "16px",
                            color: "red",
                            fontWeight: "700",
                          }}
                          className="mdi mdi-close"
                          onClick={() => setSelectedFiles([])}
                        />
                      </Col>
                    </Row>
                    {importActivated.current && (
                      <Row className="align-items-center">
                        <Col>
                          <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                        </Col>
                      </Row>
                    )}
                  </div>
                </Card>
              ))}
            </div>
          </Form>

          <div className="text-center mt-3">
            <p style={{ color: "red" }}>{imgError}</p>
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={uploadService}
            >
              Enviar Estoques
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={cancelImport}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
